export default "__VITE_ASSET__45751dbd__"